import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from "@devhop/ui";
import { useState } from "react";

type RejectExpenseDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (rejectionReason?: string) => Promise<void>;
  isPending?: boolean;
};

export function RejectExpenseDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: RejectExpenseDialogProps) {
  const [rejectionReason, setRejectionReason] = useState("");

  const handleConfirm = async () => {
    await onConfirm(rejectionReason || undefined);
    setRejectionReason("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ປະຕິເສດຄ່າໃຊ້ຈ່າຍ</DialogTitle>
        </DialogHeader>
        <Textarea
          placeholder="ເຫດຜົນ (ບໍ່ບັງຄັບ)"
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          rows={3}
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            ຍົກເລີກ
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            ປະຕິເສດ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
